(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root) {
    root.querySelectorAll('[data-release-countdown]').forEach((countdown) => {
      if (countdown.dataset.initialized) return;
      countdown.dataset.initialized = 'true';
      const display = countdown.querySelector('[data-release-display]');
      if (motion.matches) return;
      const started = performance.now();
      function scramble() {
        if (!countdown.isConnected) return;
        if (motion.matches || performance.now() - started >= 2400) {
          display.textContent = 'RELEASE DATE TO BE ANNOUNCED';
          return;
        }
        display.textContent = Array.from({ length: 4 }, () =>
          String(Math.floor(Math.random() * 100)).padStart(2, '0')
        ).join(' : ');
        window.setTimeout(scramble, 65);
      }
      scramble();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
